import { format } from 'date-fns'

/**
 * Normalize audit / change-log `created_at` to epoch ms (ISO string, Unix seconds, or ms).
 */
export function changeLogCreatedAtToMs(
  value: string | number | undefined | null,
): number | null {
  if (value === undefined || value === null || value === '') return null

  if (typeof value === 'number' && Number.isFinite(value)) {
    return value > 0 && value < 1e12 ? value * 1000 : value
  }

  const s = String(value).trim()
  if (!s) return null

  if (/^\d+$/.test(s)) {
    const n = Number(s)
    if (Number.isFinite(n) && n > 0) {
      return n < 1e12 ? n * 1000 : n
    }
    return null
  }

  const normalized = s.includes('T') ? s : s.replace(/^(\d{4}-\d{2}-\d{2})\s+/, '$1T')
  const parsed = Date.parse(normalized)
  return Number.isNaN(parsed) ? null : parsed
}

/**
 * Audit / change-log `created_at` display.
 * Default pattern matches Angular `{{ note.created_at | date:'MM/dd/yyyy hh:mm a' }}`.
 */
export function formatChangeLogCreatedAt(
  value: string | number | undefined | null,
  pattern = 'MM/dd/yyyy hh:mm a',
): string {
  const ms = changeLogCreatedAtToMs(value)
  if (ms === null) {
    return value === undefined || value === null ? '' : String(value).trim()
  }
  const date = new Date(ms)
  if (Number.isNaN(date.getTime())) {
    return value === undefined || value === null ? '' : String(value).trim()
  }
  return format(date, pattern)
}
